
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
//import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from "react-router-dom";

import PropTypes from "prop-types";
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { Switch, Route } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuIcon from '@mui/icons-material/Menu';
import colors from 'assets/mavric-theme/base/colors';
import borders from "assets/mavric-theme/base/borders";
import PersonIcon from '@mui/icons-material/Person';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logout } from "actions/auth";
import Grid from '@mui/material/Grid';
import store from 'components/store.js';
import WohlerLogo from "assets/img/wohler_logo_295x117.png";

import packageJson from '../../../package.json';

import { useCookies } from 'react-cookie';
import Footer from './Footer';

const { text, background, white } = colors;
const { borderRadius } = borders;

const drawerWidth = 250;

const openedMixin = (theme) => ({
  width: drawerWidth,
  backgroundColor: background.sidenav,
  borderRadius: borderRadius.lg,
  //margin: `0 ${pxToRem(16)}`,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  backgroundColor: background.sidenav,
  borderRadius: borderRadius.lg,
  //margin: `0 ${pxToRem(16)}`,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  // [theme.breakpoints.up('sm')]: {
  //   width: `calc(${theme.spacing(8)} + 1px)`,
  // },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  backgroundColor: background.sidenav,
  borderRadius: borderRadius.xxl,
  border: "none",

  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function MDrawer(props) {
  // const features = useSelector(state => typeof(state.features) === "string" ? JSON.parse(state.features) : state.features);
  let filteredRoutes = props.routes;
  // console.log("filteredRoutes: ", filteredRoutes);

  // const stateCustomerId = useSelector(state => state.customerId);
  const MyStateRole = useSelector(state => state.role);
  const state = { ...store.getState() };
  // console.log("State from store: ", state);


  const switchRoutes = (
    <Switch>
      {props.routes.map((prop, key) => {
        if (prop.layout === "/support") {
          if (prop.children && Array.isArray(prop.children) && prop.children.length > 0) {
            // Logic for nested (child) routes under "/support"
            let child_routes = [];

            prop.children.map((child_prop, child_key) => {
              // Creating a route for each child route
              child_routes.push(
                <Route
                  path={prop.layout + prop.path + child_prop.path}
                  component={child_prop.component}
                  key={`${key}.${child_key}`}
                />
              );

              // Check if the child route has a dynamic parameter (e.g., /support/:id)
              if (typeof child_prop.param === "string") {
                child_routes.push(
                  <Route
                    path={prop.layout + prop.path + child_prop.path + "/:" + child_prop.param}
                    component={child_prop.component}
                    key={`${key}.${child_key}.${child_prop.param}`}
                  />
                );
              }
            });

            // Return the array of child routes
            return child_routes;

          } else {
            // Logic for a single route (no nested routes) under "/support"
            if (typeof prop.param === "string") {
              return (
                <>
                  <Route
                    path={prop.layout + prop.path}
                    component={prop.component}
                    key={key}
                  />
                  <Route
                    path={prop.layout + prop.path + "/:" + prop.param}
                    component={prop.component}
                    key={`${key}.${prop.param}`}
                  />
                </>
              );
            } else {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            }
          }
        } else if (prop.layout === "/accounting") {
          if (prop.children && Array.isArray(prop.children) && (prop.children.length > 0)) {

            let child_routes = [];

            prop.children.map((child_prop, child_key) => {

              child_routes.push(<Route
                path={prop.layout + prop.path + child_prop.path}
                component={child_prop.component}
                key={`${key}.${child_key}`}
              />);

              if (typeof child_prop.param === "string") {
                child_routes.push(<Route
                  path={prop.layout + prop.path + child_prop.path + "/:" + child_prop.param}
                  component={child_prop.component}
                  key={`${key}.${child_key}.${child_prop.param}`}
                />);
              }

            })

            return child_routes;

          } else {
            if (typeof prop.param === "string") {
              return (<>
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
                <Route
                  path={prop.layout + prop.path + "/:" + prop.param}
                  component={prop.component}
                  key={`${key}.${prop.param}`}
                />
              </>)
            } else {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            }

          }

        } else if (prop.layout === "/salesadmin") {
          if (prop.children && Array.isArray(prop.children) && (prop.children.length > 0)) {

            let child_routes = [];

            prop.children.map((child_prop, child_key) => {

              child_routes.push(<Route
                path={prop.layout + prop.path + child_prop.path}
                component={child_prop.component}
                key={`${key}.${child_key}`}
              />);

              if (typeof child_prop.param === "string") {
                child_routes.push(<Route
                  path={prop.layout + prop.path + child_prop.path + "/:" + child_prop.param}
                  component={child_prop.component}
                  key={`${key}.${child_key}.${child_prop.param}`}
                />);
              }

            })

            return child_routes;

          } else {
            if (typeof prop.param === "string") {
              return (<>
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
                <Route
                  path={prop.layout + prop.path + "/:" + prop.param}
                  component={prop.component}
                  key={`${key}.${prop.param}`}
                />
              </>)
            } else {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            }

          }

        } else if (prop.layout === "/salesoperator") {
          if (prop.children && Array.isArray(prop.children) && (prop.children.length > 0)) {

            let child_routes = [];

            prop.children.map((child_prop, child_key) => {

              child_routes.push(<Route
                path={prop.layout + prop.path + child_prop.path}
                component={child_prop.component}
                key={`${key}.${child_key}`}
              />);

              if (typeof child_prop.param === "string") {
                child_routes.push(<Route
                  path={prop.layout + prop.path + child_prop.path + "/:" + child_prop.param}
                  component={child_prop.component}
                  key={`${key}.${child_key}.${child_prop.param}`}
                />);
              }

            })

            return child_routes;

          } else {
            if (typeof prop.param === "string") {
              return (<>
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
                <Route
                  path={prop.layout + prop.path + "/:" + prop.param}
                  component={prop.component}
                  key={`${key}.${prop.param}`}
                />
              </>)
            } else {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            }

          }

        } else if (prop.layout === "/dealeradmin") {
          if (prop.children && Array.isArray(prop.children) && (prop.children.length > 0)) {

            let child_routes = [];

            prop.children.map((child_prop, child_key) => {

              child_routes.push(<Route
                path={prop.layout + prop.path + child_prop.path}
                component={child_prop.component}
                key={`${key}.${child_key}`}
              />);

              if (typeof child_prop.param === "string") {
                child_routes.push(<Route
                  path={prop.layout + prop.path + child_prop.path + "/:" + child_prop.param}
                  component={child_prop.component}
                  key={`${key}.${child_key}.${child_prop.param}`}
                />);
              }

            })

            return child_routes;

          } else {
            if (typeof prop.param === "string") {
              return (<>
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
                <Route
                  path={prop.layout + prop.path + "/:" + prop.param}
                  component={prop.component}
                  key={`${key}.${prop.param}`}
                />
              </>)
            } else {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            }

          }

        } else if (prop.layout === "/dealeroperator") {
          if (prop.children && Array.isArray(prop.children) && (prop.children.length > 0)) {

            let child_routes = [];

            prop.children.map((child_prop, child_key) => {

              child_routes.push(<Route
                path={prop.layout + prop.path + child_prop.path}
                component={child_prop.component}
                key={`${key}.${child_key}`}
              />);

              if (typeof child_prop.param === "string") {
                child_routes.push(<Route
                  path={prop.layout + prop.path + child_prop.path + "/:" + child_prop.param}
                  component={child_prop.component}
                  key={`${key}.${child_key}.${child_prop.param}`}
                />);
              }

            })

            return child_routes;

          } else {
            if (typeof prop.param === "string") {
              return (<>
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
                <Route
                  path={prop.layout + prop.path + "/:" + prop.param}
                  component={prop.component}
                  key={`${key}.${prop.param}`}
                />
              </>)
            } else {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            }

          }

        }
        return null;
      })}
    </Switch>
  );

  console.log("m-drawer", window.location.pathname);
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const [hover, setHover] = useState(false);
  const [isMultiview, setMultiviewDrawer] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedChildIndex, setSelectedChildIndex] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const history = useHistory();

  const UserId = useSelector(state => state.userid);
  const Token = useSelector(state => state.accessToken);
  const UserFirstName = useSelector(state => state.firstName);
  const UserLastName = useSelector(state => state.lastName);
  const RoleId = useSelector(state => state.roleId);

  const version = packageJson.version != null ? packageJson.version : "";
  const antMediaVersion = localStorage.getItem("ANTMediaVersion") != null ? localStorage.getItem("ANTMediaVersion") : "";
  // let hiddenMenuOptionsList = new Set(["Probeview", "ProbeviewVideo"]);
  const dispatch = useDispatch();


  useEffect(() => {
    // const currentPath = location.pathname.toLowerCase();
    // console.log("currentPath:------>",currentPath);
    // if(props.preSelected !== undefined && props.preSelected.trim().length > 0){
    //   setSelectedIndex(selectedIndex);
    // }
    const matchedItem = filteredRoutes.find(item => location.pathname.startsWith(item.layout + item.path));
    // console.log("matchedItem: ", matchedItem);
    if (matchedItem) {
      setSelectedIndex(matchedItem.name);
      setSelectedChildIndex("");
      const matchedChild = matchedItem.children.find(child => {
        return (
          location.pathname.endsWith(child.path) ||
          location.pathname.includes(matchedItem.layout + matchedItem.path + child.path))
      }
      );
      // console.log("matchedChild:----------> ",matchedChild);
      if (matchedChild) {
        setSelectedChildIndex(matchedChild.name);
      }
    }
  }, [props, location.pathname]);

  // useEffect(() => {
  //   console.log("Updated selectedIndex: ", selectedIndex);
  //   console.log("Updated selectedChildIndex: ", selectedChildIndex);
  // }, [selectedIndex, selectedChildIndex]);


  const handleDrawerOpen = () => {
    //console.log("m-drawer:handleDrawerOpen::");
    setOpen(true);
    setHover(false);
  };

  const handleDrawerClose = () => {
    //console.log("m-drawer:handleDrawerClose::");
    setOpen(false);
    setHover(true);
  };

  const handleListItemClick = (event, name) => {
    //console.log("m-drawer:handleListItemClick::", Date().toLocaleString());
    if (name === "Logout") {
      handleLogout();
    } else {
      setSelectedIndex(name);
      setSelectedChildIndex("");
    }
  };

  const handleChildListItemClick = (event, name) => {
    setSelectedChildIndex(name);
  };

  const hdlrChildListItemExtLnkClick = (event, name, extLink) => {
    setSelectedChildIndex("/setup");
    window.open(extLink, '_blank', 'noopener');
  };

  const MouseOver = () => {
    //console.log("m-drawer:MouseOver::", Date().toLocaleString())
    setOpen(true);
  }

  const MouseOut = () => {
    //console.log("m-drawer:MouseOut::", Date().toLocaleString())
    setOpen(false);
  }

  function removeCookie(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  const handleLogout = () => {
    localStorage.removeItem("ANTMediaVersion");
    removeCookie("token");
    // let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
    const { userid, roleId, accessToken } = store.getState();
    // const jsonPostMsg = {
    //   "user_id": parseInt(userid),
    //   "access_token": accessToken,
    //   "role_id": parseInt(roleId)
    // };
    let jsonPostMsg = {
      "user_id": UserId,
      "token": Token,
    };
    dispatch(logout(jsonPostMsg));
    history.push('/login');
  };

  return (
    <Box sx={{
      display: 'block',
      width: (hover || isMultiview) ? `calc(100% - ${theme.spacing(7)} + 1px)` : `calc(100% - ${drawerWidth}px)`,
      float: "right", flexGrow: 1
    }}
    >
      <AppBar position="fixed" open={open}>
        <Toolbar sx={{ justifyContent: isMultiview ? 'right' : 'space-between' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            sx={{
              ml: open ? 0 : `calc(${theme.spacing(7)} + 1px)`,
              ...(open && { display: 'none' }),
              ...(isMultiview && { display: 'none' })
            }}
          >
            <MenuIcon sx={{ color: text.main }} />
          </IconButton>
          <IconButton onClick={handleDrawerClose}
            sx={{
              opacity: open ? 1 : 0,
              display: open ? 'block' : 'none',
              ml: open ? `${drawerWidth}px` : 0,
              ...(isMultiview && { display: 'none' })
            }}>
            <MenuOpenIcon sx={{ color: text.main }} />
          </IconButton>
          <Box sx={{ flexGrow: 1, textAlign: 'right' }} />

          <Box sx={{ flexGrow: 1 }} />
          {/* <Typography variant="h6" noWrap sx={{ textTransform: 'capitalize' }}>
            {UserFirstName}&nbsp;{UserLastName}
          </Typography> */}
          <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'right', mt: 1 }}>
            <Typography variant="h6" noWrap sx={{ textTransform: 'capitalize', color: text.main, }}>
              {UserFirstName}&nbsp;{UserLastName}
            </Typography>
            <Typography variant="body2" noWrap sx={{ textTransform: 'capitalize', color: 'gray', mt: "-6px", fontSize: '0.9rem' }}>
              {MyStateRole}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open} onMouseEnter={hover ? MouseOver : null} onMouseLeave={hover ? MouseOut : null} sx={{ zIndex: 2, }}>
        <DrawerHeader>
          <IconButton sx={{ display: open ? 'none' : 'block', p: 0, ml: 0.5 }}>
            <Avatar sx={{ bgcolor: 'transparent' }} variant="square" src={props.slogo} />
          </IconButton>

          <img src={props.logo}
            id="wohler-logo"
            alt="Wohler Logo"
            style={{ width: "100%", display: open ? 'block' : 'none' }}
          />
        </DrawerHeader>
        <List component="nav"
          sx={{
            '&& .Mui-selected, && .Mui-selected:hover': {
              bgcolor: '#1295ED',
              '&, & .MuiListItemIcon-root': {
                color: '#FFFFFF',
              },
            },
            '& .MuiListItemButton-root:hover': {
              bgcolor: '#236995',
              '&, & .MuiListItemIcon-root': {
                color: '#E5E5E5',
              },
            },
          }}
        >
          {filteredRoutes.map((item, index) => (item.children.length !== 0 ?

            <ListItem key={index} disablePadding sx={{ display: 'block', }} component={Link} to={item.layout + item.path + item.children[0].path}>
              <ListItemButton
                selected={selectedIndex === item.name}
                onClick={(event) =>
                  handleListItemClick(event, item.name)
                }
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  color: white.main,
                  '&.Mui-selected': {
                    backgroundColor: '#236995',
                    '& .MuiListItemIcon-root, & .MuiTypography-root': {
                      color: '#FFFFFF',
                    }, 
                  },
                  '&:hover': {
                    '& .MuiListItemIcon-root, & .MuiTypography-root, & .MuiSvgIcon-root': {
                      color: '#FFFFFF !important',
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 2 : 'auto',
                    justifyContent: 'center',
                    display: 'block',
                    color: selectedIndex === item.name ? '#FFFFFF' : '#4c4d4f',
                  }}
                >
                  {<item.icon sx={{ color: 'inherit' }} />}
                </ListItemIcon>
                <ListItemText
                  disableTypography
                  primary={<Typography variant="body2" style={{ color: selectedIndex === item.name ? '#FFFFFF' : text.main, }}>{item.name}</Typography>} sx={{ opacity: open ? 1 : 0, display: 'block', }} />
                {item.name === selectedIndex ? <KeyboardArrowDown sx={{ color: '#FFFFFF' }} /> : <KeyboardArrowUpIcon sx={{ color: selectedIndex === item.name ? '#FFFFFF' : text.main }} />}
              </ListItemButton>
              {item.name === selectedIndex &&
                item.children.map((child, index) => (
                  <ListItem key={child.name} disablePadding
                    sx={{
                      display: 'block',
                      '&& .Mui-selected, && .Mui-selected:hover': {
                        bgcolor: '#236995',
                        '&, & .MuiListItemIcon-root': {
                          color: '#FFFFFF',
                        },
                      },
                    }}
                    component={Link} to={item.layout + item.path + child.path}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? 'initial' : 'center',
                        '&.Mui-selected': {
                          backgroundColor: '#236995',
                          '& .MuiListItemIcon-root, & .MuiTypography-root': {
                            color: '#FFFFFF',
                          },
                        },
                        '&:hover': { '& .MuiListItemIcon-root, & .MuiTypography-root': { color: '#FFFFFF !important', }, },
                      }}
                      selected={(selectedChildIndex === child.name)}
                      onClick={(event) => {
                        handleChildListItemClick(event, child.name);
                      }
                      }
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 2 : 'auto',
                          ml: open ? 2 : 'auto',
                          justifyContent: 'center',
                          '&:hover': { '& .MuiListItemIcon-root, & .MuiTypography-root': { color: '#FFFFFF !important', }, },
                          color: selectedChildIndex === child.name ? '#FFFFFF' : '#4c4d4f',
                        }}
                      >
                        {<child.icon sx={{ color: 'inherit' }} />}
                      </ListItemIcon>
                      <ListItemText
                        disableTypography
                        primary={<Typography variant="body2" style={{ color: selectedChildIndex === child.name ? '#FFFFFF' : text.main, }}>{child.name}</Typography>} sx={{ opacity: open ? 1 : 0 }}
                      />
                    </ListItemButton>
                  </ListItem>
                  // )
                ))}
            </ListItem>
            :
            // ((isSsoUser && (item.path === "/reset-password")) ? <Grid></Grid> :
            <ListItem
              key={item.name}
              disablePadding
              sx={{ display: 'block', '&& .Mui-selected, && .Mui-selected:hover': { bgcolor: '#236995', '&, & .MuiListItemIcon-root': { color: '#FFFFFF', }, }, }} component={Link} to={item.layout + item.path}>
              <ListItemButton sx={{ minHeight: 48, justifyContent: open ? 'initial' : 'center', '&:hover': { '& .MuiListItemIcon-root, & .MuiTypography-root': { color: '#FFFFFF !important', }, }, }} selected={selectedIndex === item.name} onClick={(event) => handleListItemClick(event, item.name)}>
                <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : 'auto', justifyContent: 'center', display: 'block', color: selectedIndex === item.name ? '#FFFFFF' : '#4c4d4f', }}>
                  {<item.icon sx={{ color: 'inherit' }} />}
                </ListItemIcon>
                <ListItemText disableTypography primary={<Typography variant="body2" style={{ color: selectedIndex === item.name ? '#FFFFFF' : text.main, }}>{item.name}</Typography>} sx={{ opacity: open ? 1 : 0, display: 'block', }} /></ListItemButton>
            </ListItem>
            // )
          ))}
        </List>
      </Drawer>
      <Box component="main" sx={{ p: 1.5, mt: 7.5, zIndex: 1, height: '100%', }}>
        {switchRoutes}
      </Box>
      <Footer sidebarOpen={open} MDrawer={true} />
    </Box>
  );
}

MDrawer.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
};
